import React from 'react'

const Footer = () => {
    return (
        <div id="main-footer">
            <div id="email-letter">
                <p className="center">
                    <i className="fas fa-envelope fa-2x"></i>
                    <span className="secondary">Email-letter</span>
                </p>
                <p>Subscribe to our Email Letter to get instant update about Latest Cricket news.</p>
                <form id="eletter-form">
                    <input type="email" placeholder="Enter your Email-id"></input>
                    <input type="submit" value="Subscribe"></input>
                </form>
            </div>
            <div id="social-media">
                <p className="center">
                    <i className="fas fa-comments fa-2x"></i>
                    <span className="secondary">Follow us</span>
                </p>
                <div className="links">
                    <a href="https://www.instagram.com/sri_jayan_17/" target="blank">
                        <i className="fab fa-instagram fa-2x"></i>
                    </a>
                    <a href="https://www.facebook.com/esrijayan.srijayan" target="blank">
                        <i className="fab fa-facebook fa-2x"></i>
                    </a>
                    <a href="https://github.com/SriJayan17" target="blank">
                        <i className="fab fa-github fa-2x"></i>
                    </a>
                    <a href="https://www.youtube.com/" target="blank">
                        <i className="fab fa-youtube fa-2x"></i>
                    </a>
                </div>
                <p className="center">Support us by following on social media.</p>
            </div>
            <div id="contact">
                <p className="center">
                    <i className="fas fa-phone-square-alt fa-2x"></i>
                    <span className="secondary">Contact</span>
                </p>
                <p>To contact us reagrding promotion or queries text me on whatsapp 9361482979.</p>
            </div>
            <div id="copy">
                <p className="center">
                    <i className="fas fa-copyright fa-2x"></i>
                    <span className="secondary">SJ Games </span>
                    <i className="fas fa-trademark"></i>
                    <span className="secondary"> All rights Reserved 2025</span>
                </p>
            </div>
        </div>
    )
}

export default Footer
